// extracted by mini-css-extract-plugin
module.exports =  {"seller-level-tooltip":"QLFfmdu","sellerLevelTooltip":"QLFfmdu","seller-level":"VygP5En","sellerLevel":"VygP5En","top-rated":"afa6Zpu","topRated":"afa6Zpu"};